import React from 'react';
import { useSelector } from 'react-redux';

import { ModalEmptyMessage } from 'modules/ui/components';
import { sortedServerRoutingsListSelector } from '../../redux/selectors';
import Row from './Row';
import RowV2 from './RowV2';

const EMPTY_MESSAGE_TITLE = 'No new server routings in the last 7 days.';
const EMPTY_MESSAGE_SUBTITLE =
  'You might have already downloaded them all to the Downloaded routings tab. You can also create a new routing by right-clicking on the map.';

const ServerRoutingsList: React.FC = () => {
  const routings = useSelector(sortedServerRoutingsListSelector);
  const isEmpty = !routings.length;

  return (
    <>
      {isEmpty && (
        <ModalEmptyMessage
          title={EMPTY_MESSAGE_TITLE}
          subtitle={EMPTY_MESSAGE_SUBTITLE}
        />
      )}
      {routings.map((r) =>
        r.v === 2 ? (
          <RowV2 key={r.id} route={r} />
        ) : (
          <Row key={r.id} route={r} />
        ),
      )}
    </>
  );
};

export default React.memo(ServerRoutingsList);
